<template>
  <transition name="slide-right">
    <cube-popup
      ref="myPopup"
      :visible="visible"
      type="my-popup"
      :center="false"
      position="right"
      class="filter-wrap"
    >
      <div
        ref="tree"
        class="tree_main"
      >
        <cube-scroll
          ref="treeScroll"
          :data="menus"
        >
          <Tree
            v-if="menus.length > 0"
            :menus="menus"
            :depth="depth"
            :act-id="actId"
            @selectItem="selectItem"
            @checkItem="checkItem"
          />
          <div style="height: 65px" />
        </cube-scroll>
      </div>
      <div
        class="foot-main"
      >
        <cube-button
          @click.stop="hide"
        >
          {{ $t('message["896"]') }}
        </cube-button>
        <cube-button
          type="submit"
          @click.stop="hide"
        >
          {{ $t('message["915"]') }}
        </cube-button>
      </div>
    </cube-popup>
  </transition>
</template>
<script type="text/ecmascript-6">
import Tree from './Tree'
export default {
  components: {
    Tree
  },
  props: {
    data: {
      type: Array,
      default: () => ({})
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isVisible: false,
      depth: 0,
      menus: [],
      actId: '',
      // 选中的值
      checkedList: [],
      aTitle: []
    }
  },
  watch: {
    visible (val) {
      this.isVisible = val
    },
    data (newVal) {
      this.menus = newVal
      this.addShow(this.menus)
    },
    checkedList (newVal) {
      let data = this.perpareReturnData(newVal)
      this.perpareParamsTitle(this.menus, data)
      this.$emit('check', { value: data, members: this.aTitle })
    }
  },
  mounted () {
    this.addShow(this.menus)
  },
  methods: {
    hide () {
      this.$refs.myPopup.hide()
      this.$emit('close', false)
    },
    perpareReturnData (keys) {
      let returnData = []
      let snapKeys = [].concat(...keys)
      let snapCache = []
      let aOne = []
      let aTwo = []
      for (let i = snapKeys.length - 1; i >= 0; i--) {
        let item = snapKeys[i].split('|')
        if (item.length === 1 || item.length === 2) {
          snapCache.push(snapKeys[i])
          snapKeys.splice(i, 1)
        }
      }
      for (let i = 0; i < snapCache.length; i++) {
        let item = snapCache[i]
        let len = snapKeys.length - 1
        for (let k = len; k >= 0; k--) {
          if (snapKeys[k] && snapKeys[k].indexOf(item) !== -1) {
            snapKeys.splice(k, 1)
          }
        }
      }
      returnData = snapCache.concat(snapKeys)
      for (let i = returnData.length - 1; i >= 0; i--) {
        let aItem = returnData[i].split('|')
        if (aItem.length > 1) {
          aTwo.push(returnData[i])
        } else {
          aOne.push(returnData[i])
        }
      }
      for (let i = 0; i < aOne.length; i++) {
        for (let j = aTwo.length - 1; j >= 0; j--) {
          if (aTwo[j].includes(aOne[i])) {
            aTwo.splice(j, 1)
          }
        }
      }
      return aOne.concat(...aTwo)
    },
    perpareParamsTitle (keys, params) {
      this.aTitle = []
      for (let i = 0; i < params.length; i++) {
        let pItem = params[i]
        this.getParamsTitle(keys, pItem)
      }
    },
    getParamsTitle (arr, value) {
      for (let i = 0; i < arr.length; i++) {
        let item = arr[i]
        if (item.key === value) {
          this.aTitle.push(item.title)
          break
        }
        if (item.children) {
          this.getParamsTitle(item.children, value)
        }
      }
    },
    // 递归函数在每一项中添加selectArr和show
    addShow (arr) {
      for (let i = 0; i < arr.length; i++) {
        this.$set(arr[i], 'show', false)
        this.$set(arr[i], 'selectArr', [])
        if ('children' in arr[i] && arr[i].children.length > 0) {
          this.addShow(arr[i].children)
        }
      }
    },
    // 点击箭头使树展开收缩
    selectItem (data) {
      if (data.children && data.children.length > 0) {
        // 如果此项下有userList且length大于0，则切换展开与折叠状态
        data.show = !data.show
      } else {
        // 如果此项下没有userList或length等于0，则将选中的id赋值给actId
        this.actId = data.value
      }
    },
    // 进行多选勾选
    checkItem (data) {
      this.checkedList = []
      if (data.selectArr.length > 0) {
        // 如果这一项的selectArr有值，说明是被勾选状态，要把selectArr清空，清空勾选
        data.selectArr = []
        // 如果此选项清空勾选后，如果下面有userList的话，那么也同时要清空
        if (data.children && data.children.length > 0) {
          this.clearChild(data.children)
        }
        // 如果此选项清空勾选后，要把所有的父元素，也全部清空勾选，因为它不勾选了，所有父元素的状态不可能还处于勾选状态，不管它勾选不勾选，我们都要清除一遍，以防万一
        this.clearFather(this.menus, data)
      } else {
        // 如果这一项的selectArr为[]，说明是未被勾选状态，在selectArr里加value值，添加勾选
        data.selectArr.push(data.value)
        // 如果此选项清空勾选后，如果下面有userList的话，那么也同时勾选下面所有的孩子
        if (data.children && data.children.length > 0) {
          this.addChild(data.children)
        }
        // 如果此选项勾选后，要判断所有的上级元素是不是应该全部打勾
        this.selectFather(this.menus, data)
      }
      this.perpareCheckedValue(this.menus)
    },
    // 收集选择的value
    perpareCheckedValue (arr) {
      for (let i = 0; i < arr.length; i++) {
        const { value } = arr[i]
        if (arr[i].selectArr.length > 0) {
          this.checkedList.push(value)
        }
        if ('children' in arr[i]) {
          this.perpareCheckedValue(arr[i].children)
        }
      }
    },
    // 定义函数清空所有孩子的勾选
    clearChild (arr) {
      for (let i = 0; i < arr.length; i++) {
        arr[i].selectArr = []
        if (arr[i].children && arr[i].children.length > 0) {
          this.clearChild(arr[i].children)
        }
      }
    },
    // 定义函数添加所有孩子的勾选
    addChild (arr) {
      for (let i = 0; i < arr.length; i++) {
        arr[i].selectArr.push(arr[i].value)
        if (arr[i].children && arr[i].children.length > 0) {
          this.addChild(arr[i].children)
        }
      }
    },
    // 定义函数一层一层的往上寻找父元素的userList
    clearFather (father, data) {
      for (let i = 0; i < father.length; i++) {
        if (father[i].value === data.value) {
          // 找到data所在的userList为father，然后再通过这个userList找到拥有这个userList的父元素
          this.clearRealFather(this.menus, father)
        } else if (father[i].children && father[i].children.length > 0) {
          this.clearFather(father[i].children, data)
        }
      }
    },
    // 定义函数根据找到的上层父元素的userList来寻找父元素，并将他们清除勾选
    clearRealFather (menus, arr) {
      for (let i = 0; i < menus.length; i++) {
        if (menus[i].children === arr) {
          // 找到这个拥有userList的父元素后，将此selectArr清空
          menus[i].selectArr = []
          // 找到这个拥有userList的父元素后，再调用clearFather，再进行向上寻找父元素，知道没有父元素为止
          this.clearFather(this.menus, menus[i])
        } else if (menus[i].children && menus[i].children.length > 0) {
          this.clearRealFather(menus[i].children, arr)
        }
      }
    },
    // 定义函数一层一层的往上寻找父元素的children
    selectFather (father, data) {
      for (let i = 0; i < father.length; i++) {
        if (father[i].value === data.value) {
          let arr = []
          for (let j = 0; j < father.length; j++) {
            if (father[j].selectArr.length > 0) {
              arr.push(father[i])
            }
          }
          // 判断此数组中是不是所有的selectArr都有值，如果有值，就执行selectRealFather，将上层父元素也勾选
          if (arr.length === father.length) {
            this.selectRealFather(this.menus, father)
          }
        } else if (father[i].children && father[i].children.length > 0) {
          this.selectFather(father[i].children, data)
        }
      }
    },
    // 定义函数根据找到的上层父元素的userList来寻找父元素，并将他们清除勾选
    selectRealFather (menus, arr) {
      for (let i = 0; i < menus.length; i++) {
        if (menus[i].children === arr) {
          // 找到这个拥有userList的父元素后，给selectArr赋值，使其勾选
          menus[i].selectArr.push(menus[i].value)
          // 找到这个拥有userList的父元素后，再调用clearFather，再进行向上寻找父元素，知道没有父元素为止
          this.clearFather(this.menus, menus[i])
        } else if (menus[i].children && menus[i].children.length > 0) {
          this.selectRealFather(menus[i].children, arr)
        }
      }
    }
  }
}

</script>
<style lang="scss" scoped>
.slide-right-enter,
.slide-right-leave-active {
  -webkit-transform: translate3d(100%, 0, 0);
  transform: translate3d(100%, 0, 0);
}

.slide-right-enter-active,
.slide-right-leave-active {
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
}

.tree_main {
  padding: 12px 0;
  position: relative;
  // top: 0;
  height: 100%;
}
.foot-main {
  position: fixed;
  width: 100%;
  height: 62px;
  bottom: 0;
  z-index: 100;
  background: #fff;
  button {
    display: inline-block;
    width: 176px;
    height: 46px;
    box-sizing: border-box;
    background: #fff;
    border:1px solid rgba(219,219,219,1);
    color: #333;
    margin: 8px;
  }
  button[type="submit"] {
    margin: 8px 0 0 0;
    background:linear-gradient(360deg,rgba(80,119,170,1) 0%,rgba(96,143,204,1) 100%);
    box-shadow:0px 1px 1px 0px rgba(255,255,255,0.5);
    border-radius:4px;
    border:1px solid rgba(80,119,170,1);
    color: #fff
  }
}
</style>
